import { Component, EventEmitter, Output } from "@angular/core";
import { NavigationService } from "src/services/navigation/navigation.service";
import { MessageService } from "src/services/message/message.service";
import { isItemQrCode } from "src/services/qr-code/qr-code.interface";

@Component({
  selector: "rc-item-scanner",
  templateUrl: "./item-scanner.component.html",
  styleUrls: ["./item-scanner.component.scss"],
  standalone: false,
})
export class ItemScannerComponent {
  @Output() public onQrCodeScanned = new EventEmitter<string>();

  private processingCode = false;

  constructor(
    public readonly navigationService: NavigationService,
    private readonly messageService: MessageService,
  ) {}

  public async tryHandleQrCodeScanned(qrCodeString: string): Promise<void> {
    if (this.processingCode) {
      return;
    }

    this.processingCode = true;
    try {
      this.onQrCodeScanned.emit(await this.getItemFromQrCodeOrThrow(qrCodeString));
    } catch (error) {
      await this.messageService.presentErrorToast(error.message);
    } finally {
      this.processingCode = false;
    }
  }

  private async getItemFromQrCodeOrThrow(qrCodeString: string): Promise<string> {
    let qrCode: unknown;
    try {
      qrCode = JSON.parse(qrCodeString);
    } catch {
      await this.messageService.presentErrorToast("This QR code can't be read");
    }

    if (!isItemQrCode(qrCode)) {
      throw new Error("This QR code doesn't contain item information");
    }

    return qrCode.itemId;
  }
}
